module.exports = __webpack_public_path__ + "img/s-hd.1ed0fa59.jpg";